<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="id !== null ? 'Update' : 'Create'"
  >
    <template slot="header">
      <span>{{ id !== null ? 'Update' : 'Create' }} Client</span>
    </template>

    <template slot="body">
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-text-field
            v-model="name"
            label="Name"
            :rules="[
              (v) => !!v || 'Client Name is required',
              (v) => !!v && v.length <= 45 || 'Max 45 characters'
            ]"
            counter="45"
          >
            <template slot="label">
              Name<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="pb-0 pt-0"
        >
          <v-text-field
            v-model="phone_number"
            label="Phone Number"
            :rules="[(v) => (v === null || v.length <= 20) || 'Max 20 characters']"
            counter="20"
            @blur="formatPhoneNumber"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="pb-0">
          <v-text-field v-model="code" label="Code" counter="45" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="pb-0 pt-0" @click="openContactForm">
          <v-select
            :value="contacts"
            readonly
            multiple
            label="Contacts"
            :items="contacts"
            item-value="name"
            item-text="name"
          />
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="6">
          <v-text-field v-model="term" label="Term" />
        </v-col>
        <v-col cols="6">
          <v-select v-model="category_id" label="Category" item-value="id" item-text="name" :items="categories" />
        </v-col>
      </v-row>
    

      <v-row>
        <v-col
          cols="6"
          class="pb-0 pt-0"
        >
          <v-select
            v-model="account_status_id"
            :items="accountStatusOptions"
            item-value="id"
            item-text="name"
            label="Account Status"
          >
            <template slot="label">
              Account Status<RedAsterisk />
            </template>
          </v-select>
        </v-col>

        <v-col
          cols="6"
          class="pb-0 pt-0"
        >
          <v-select
            v-model="rank_id"
            :items="rankOptions"
            item-value="id"
            item-text="name"
            label="Rank"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="6"
          class="pb-0 pt-0"
        >
          <v-select
            v-model="satisfaction_id"
            :items="satisfactionOptions"
            item-value="id"
            item-text="name"
            label="Satisfaction"
          />
        </v-col>

        <v-col
          cols="6"
          class="pb-0 pt-0"
        >
          <v-select
            v-model="classification_id"
            :items="classificationOptions"
            item-value="id"
            item-text="name"
            label="Classification"
          />
        </v-col>
      </v-row>

      <ClientContactForm ref="contactForm" :contacts="contacts"/>
    </template>

  </the-dialog-box>
</template>

<script>
import * as FormatHelpers from '@/helpers/FormatHelpers';
import ClientContactForm from './ClientContactForm.vue';

export default {
  components: {
    ClientContactForm
  },
  data: () => ({
    id: null,
    tempId: null,
    name: '',
    code: '',
    phone_number: '',
    term: '',
    category_id: null,
    account_status_id: null,
    rank_id: null,
    satisfaction_id: null,
    classification_id: null,

    contacts: [],

    accountStatusOptions: [],
    rankOptions: [],
    satisfactionOptions: [],
    classificationOptions: [],
    categories: [],
  }),

  created() {
    this.resetForm();
    this.loadIsoOptions();
  },
  watch: {
    contacts(val) {
      console.log(val)
    }
  },

  methods: {
    async loadIsoOptions() {
      try {
        const res = await this.$api.clientIso.get();
        if (!res) return;
        
        this.accountStatusOptions = res.accountStatus || [];
        this.classificationOptions = res.classification || [];
        this.rankOptions = res.rank || [];
        this.satisfactionOptions = res.satisfactionLevel || [];
        this.categories = res.categories || [];
      } catch (e) {
        console.error('Failed to load client ISO options', e);
      }
    },

    async submit() {
      const data = {
        id: this.id,
        name: this.name,
        code: this.code,
        phone_number: this.phone_number,
        term: this.term,
        category_id: this.category_id,
        account_status_id: this.account_status_id,
        rank_id: this.rank_id,
        satisfaction_id: this.satisfaction_id,
        classification_id: this.classification_id,
        contacts: this.contacts
      }
      try {
        const res = this.id === null ? await this.$api.client.store(data) : await this.$api.client.update(data);
        if (!res) {
          this.$bus.$emit('showError', 'Failed to save the Client');
          return null;
        }
        this.$bus.$emit('showSuccess', 'Client has been saved successfully');
        this.$emit('success');
        return res;
      } catch (e) {
        console.error(e);
        this.$bus.$emit('showError', 'Failed to save the Client');
      }
    },

    resetForm() {
      this.id = null;
      this.name = '';
      this.code = '';
      this.phone_number = '';
      this.term = '';
      this.category_id = null;
      this.account_status_id = null;
      this.rank_id = null;
      this.satisfaction_id = null;
      this.classification_id = null;
      this.contacts = [];
    },

    async getContacts() {
      if (!this.id) return;
      const submitModel = {
        filters: {
          client_id: this.id
        },
      };
      const res = await this.$api.clientContact.read(submitModel);
      if (!res || res.length < 1 || !res[0]) return;
      this.contacts = res;
    },

    open(id) {
      this.resetForm();
      if (id) {
        this.$api.client.read({ filters: { id } }).then(res => {
          if (!res || !res.data[0]) return this.$bus.$emit('showError', 'Failed to load existing client');
          const client = res.data[0];
          this.id = client.id;
          this.name = client.name;
          this.code = client.code;
          this.phone_number = client.phone_number;
          this.term = client.term;
          this.category_id = client.category_id;
          this.account_status_id = client.account_status_id;
          this.rank_id = client.rank_id;
          this.satisfaction_id = client.satisfaction_id;
          this.classification_id = client.classification_id;

          this.getContacts();
        });

      } else {
        this.contacts = [];
      }
      this.$refs.dialogBox.open();
    },

    formatPhoneNumber() {
      this.phone_number = FormatHelpers.formatPhoneNumber(this.phone_number);
    },

    openContactForm() {
      this.$refs.contactForm.open();
    },
  },
};
</script>
